export enum AuthRoutes {
  Home = '/',
  Admin = '/admin',
  Test = '/test',
  Contacts = '/contacts',
  Companies = '/companies',
  Calendar = '/calendar',
  CompanyDetails = '/companies/:id',
  ContactDetails = '/contacts/:id',
  MembershipDetails = '/memberships/:id',
  Products = '/products',
  ProductDetails = '/products/:id',
  Meetings = '/meetings',
  Memberships = '/memberships',
  Invoices = '/invoices',
  MassMail = '/mail',
  Stocks = '/stocks',
  StockDetails = '/stocks/:id',
  Indices = '/indexes',
  Etfs = '/etfs',
  EtfValues = '/etfs/:id',
  Ftse = '/ftse',
  Msb = '/msb',
  Documents = '/documents',
  Event = '/event'
}

export enum PublicRoutes {
  Login = '/login'
}

export enum AdminRoutes {
  Users = '/users',
  UserDetails = '/users/:id',
  UserGroups = '/groups',
  Customization = '/customization',
  Interests = '/interests',
  FTSEConfig = '/ftse-config',
  SiteSections = '/site-sections',
  MeetingTypes = '/meeting-types'
}

export enum RouteNames {
  Login = 'login',
  Admin = 'Admin',
  AdminUsers = 'Users',
  AdminUserDetails = 'User Details',
  AdminUserGroups = 'User Groups',
  AdminCustomization = 'Customization',
  AdminInterests = 'Interests',
  AdminFtseConfig = 'FTSE Config',
  AdminSiteSections = 'Site Sections',
  AdminMeetingTypes = 'Meeting Types',
  Home = 'Overview',
  Companies = 'Companies',
  Calendar = 'Calendar',
  Contacts = 'Contacts',
  Products = 'Products',
  Meetings = 'Meetings',
  CompanyDetails = 'Company Details',
  ContactDetails = 'Contact Details',
  ProductDetails = 'Product Details',
  MembershipDetails = 'Membership Details',
  Memberships = 'Memberships',
  Invoices = 'Invoices',
  MassMail = 'Mass Mail',
  Stocks = 'Stocks',
  StockDetails = 'Stock Details',
  Indices = 'Indexes',
  Etfs = 'ETF Data',
  EtfValues = 'ETF Data',
  Ftse = 'FTSE',
  Msb = 'Msb',
  Documents = 'Documents',
  Event = 'Event'
}

export enum NavElements {
  Item = 'Item',
  Group = 'Group'
}
